import React from 'react';
import { useRouter } from 'next/router';
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
import { SubscriptionComparison, useSegment } from '@sparknz/journeys-common';
import { Recommendations } from '@sparknz/journeys-common/dist/components/SubscriptionComparison/typings';

import { SubscriptionChangePlanComparisonFieldQuery } from '__generated__/SubscriptionChangePlanComparisonFieldQuery.graphql';
import { useProductDetails } from 'journey/productDetails/provider';
import { ProductDetailsActionTypes } from 'journey/productDetails/reducer/productDetails.reducer';
import { IfpEligibilityCheckSteps } from 'journey/productDetails/typings';
import { extractFirstValue } from 'shared/utils';

export const subscriptionComparerFieldQuery = graphql`
  query SubscriptionChangePlanComparisonFieldQuery(
    $lineNumber: String!
    $addOffer: String!
    $channel: CartChannel!
  ) {
    changePlanSubscriptionsComparison(
      lineNumber: $lineNumber
      addOffer: $addOffer
      channel: $channel
    ) {
      comparisons {
        recommendationId
        available {
          offerId
          offerName
          brand
          isIncluded
          iconUrl
          price {
            basePrice
            description
            frequencyPeriod
          }
        }
        unavailable {
          offerId
          offerName
          brand
          isIncluded
          iconUrl
          price {
            description
            basePrice
            frequencyPeriod
          }
        }
        ctas {
          type
        }
      }
    }
  }
`;

const SubscriptionChangePlanComparison = () => {
  const { channel } = useSegment();
  const router = useRouter();
  const planId = extractFirstValue(router.query.planId);
  const {
    dispatch,
    ifpEligibility: { selectedLineNumber, recommendations },
  } = useProductDetails();
  const {
    changePlanSubscriptionsComparison: { comparisons },
  } = useLazyLoadQuery<SubscriptionChangePlanComparisonFieldQuery>(
    subscriptionComparerFieldQuery,
    {
      lineNumber: selectedLineNumber,
      addOffer: planId,
      channel,
    },
  );

  const addOrUpdateRecommendations = (newRecommendations: Recommendations) => {
    dispatch({
      type: ProductDetailsActionTypes.SetIfpEligibility,
      ifpEligibility: {
        activeStep: IfpEligibilityCheckSteps.ReviewPlan,
        recommendations: newRecommendations,
      },
    });
  };

  return (
    <SubscriptionComparison
      comparisons={comparisons}
      recommendations={recommendations}
      addOrUpdateRecommendations={addOrUpdateRecommendations}
      areRecommendationsSubmitted={false}
    />
  );
};

export default SubscriptionChangePlanComparison;
